import { css } from '@emotion/react';
export const headerStyles = css({
  padding: "var(--ds-space-150, 12px)",
  overflowWrap: 'break-word'
});
export const headerEditStyles = css({
  cursor: 'pointer',
  border: 'none',
  width: '100%',
  backgroundColor: 'transparent',
  color: 'inherit',
  textAlign: 'start',
  fontSize: 'unset',
  lineHeight: 'inherit',
  borderRadius: "var(--ds-border-radius-200, 4px)",
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
    textDecoration: 'underline'
  },
  '&:active': {
    backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
  },
  '&:focus': {
    outline: `2px solid ${"var(--ds-border-focused, #4C9AFF)"}`,
    outlineOffset: "var(--ds-space-negative-025, -2px)"
  }
});
export const headerWrapperStyles = css({
  display: 'flex'
});
export const headerEditRendererStyles = css({
  '&:hover': {
    textDecoration: 'none'
  }
});